var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control__elements"},[_c('div',{staticClass:"field-date-read-only-timestamp"},[_vm._v("\n    "+_vm._s(_vm.getDate(_vm.field, _vm.value))),(_vm.field.date_include_time)?[_vm._v(" "+_vm._s(_vm.getTime(_vm.field, _vm.value)))]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }